import { Component, OnInit } from '@angular/core';
import { WtfConfigService } from '../../../services/core/config.service';



@Component({
    selector   : 'wtf-error-500',
    templateUrl: './error-500.component.html',
    styleUrls  : ['./error-500.component.scss']
})
export class FuseError500Component implements OnInit
{
    constructor(
        private fuseConfig: WtfConfigService
    )
    {
        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar   : 'none',
                footer    : 'none'
            }
        });
    }

    ngOnInit()
    {
    }
}
